import { EEntities } from '@/types'
import schema from 'async-validator'

export default new class TextAssistant {
  public removeNonRTEBreaks(val: string): string {
    return val.split('\r\n').join('')
  }

  public convertNumberArrayToStringList(val: number[]): string {
    return val.length > 0 ? val.join() : ''
  }

  public isValidEmail(val: string): boolean {
    if (val === null) {
      return false
    }

    const validator = new schema({
      email: {
        type: 'email',
        required: true,
      },
    })
    let validated = false

    validator.validate({ email: val.trim() }, (errors: any, fields: any) => {
      if (!errors) {
        validated = true
      }
    })

    return validated
  }

  public urlTokenCleaner(val: string): string {
    if (val) {
      // Replace all spaces with +
      return val.replace(/ /g, '+')
    }
    return val
  }

  public entitySingularName(entityType: string): string {
    switch (entityType) {
      case EEntities.MAILBOXES:
        return 'Mailbox'
      case EEntities.PROJECTS:
        return 'Project'
    }
    return ''
  }

  public entityPluralName(entityType: string): string {
    switch (entityType) {
      case EEntities.MAILBOXES:
        return 'Mailboxes'
      case EEntities.PROJECTS:
        return 'Projects'
    }
    return ''
  }

  public itemSingularName(entityType: string): string {
    switch (entityType) {
      case EEntities.MAILBOXES:
        return 'Conversation'
      case EEntities.PROJECTS:
        return 'Task'
    }
    return ''
  }

  public itemPluralName(entityType: string): string {
    switch (entityType) {
      case EEntities.MAILBOXES:
        return 'Conversations'
      case EEntities.PROJECTS:
        return 'Tasks'
    }
    return ''
  }
}()
